export default function () {
  // No department dropdown here — the Sales Dashboard has quick-pick
  // department buttons that fill the business-unit filter directly.
  return [
    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true
      },
      collapsed: true,
      collapsedMinWidth: "450px",
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true
      },
      collapsed: true,
      collapsedMinWidth: "450px",
    },
    {
      // Takes TXF (taxes) money OUT of Total Deposits / Net.
      // Inline (collapsed: true) so it's usable without expanding the filters.
      key: 'excludeTxf',
      label: 'excludeTxf',
      type: 'checkbox',
      collapsed: true,
      props: { style: 'margin-top: 6px; white-space: nowrap' },
    },
 /*    { key: 'banner' }, { key: 'affiliate' }, { key: 'campaign' }, */

  ]
}
